
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/api-reference/2024-01/[[...slug]]",
      function () {
        return require("private-next-pages/api-reference/2024-01/[[...slug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/api-reference/2024-01/[[...slug]]"])
      });
    }
  